import React, { useContext } from "react";

export const UserPreferencesModalContext = React.createContext<{
	is_open: boolean;
	setIsOpen: (is_open: boolean) => void;
}>({
	is_open: false,
	setIsOpen: (is_open: boolean) => {},
});

export function useUserPreferencesModal() {
	return useContext(UserPreferencesModalContext);
}
